import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerHeatmapMenuItem = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.99998 2C8.44442 3.77778 9.33331 5.22222 10.6666 6.33333C12 7.44444 12.6666 8.66667 12.6666 10C12.6666 11.2377 12.175 12.4247 11.2998 13.2998C10.4246 14.175 9.23766 14.6667 7.99998 14.6667C6.7623 14.6667 5.57532 14.175 4.70015 13.2998C3.82498 12.4247 3.33331 11.2377 3.33331 10C3.33331 9.27877 3.56724 8.57699 3.99998 8C3.99998 8.44203 4.17557 8.86595 4.48813 9.17851C4.8007 9.49107 5.22462 9.66667 5.66665 9.66667C6.10867 9.66667 6.5326 9.49107 6.84516 9.17851C7.15772 8.86595 7.33331 8.44203 7.33331 8C7.33331 6.66667 6.33331 6 6.33331 4.66667C6.33331 3.77778 6.88887 2.88889 7.99998 2Z",
		stroke: "#1A1B23",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.99998 2C8.44442 3.77778 9.33331 5.22222 10.6666 6.33333C12 7.44444 12.6666 8.66667 12.6666 10C12.6666 11.2377 12.175 12.4247 11.2998 13.2998C10.4246 14.175 9.23766 14.6667 7.99998 14.6667C6.7623 14.6667 5.57532 14.175 4.70015 13.2998C3.82498 12.4247 3.33331 11.2377 3.33331 10C3.33331 9.27877 3.56724 8.57699 3.99998 8C3.99998 8.44203 4.17557 8.86595 4.48813 9.17851C4.8007 9.49107 5.22462 9.66667 5.66665 9.66667C6.10867 9.66667 6.5326 9.49107 6.84516 9.17851C7.15772 8.86595 7.33331 8.44203 7.33331 8C7.33331 6.66667 6.33331 6 6.33331 4.66667C6.33331 3.77778 6.88887 2.88889 7.99998 2Z",
		stroke: "white",
		strokeOpacity: .5,
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHypertrackerHeatmapMenuItem;
